module.exports = __webpack_public_path__ + "static/nxrt-mainpage3-77fbf67cb47c09f54dc1fefc9e583b75.jpg";